import actions from "../js/actions.js";
import $$ from "Dom7";
import URLS from "../js/Urls.js";
export default {
  methods: {
    openAlert: function () {}
  },
  data: function () {
    return {
      loginobj: {},
      eventItems: {}
    };
  },
  on: {
    pageBeforeIn: function (e, page) {},
    pageInit: async function (e, page) {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var loginobj = actions.LoginGetResult();
      var settings = await getdata();

      async function getdata() {
        let res = await app.request.promise.get(URLS.SetNotificationSettings, {
          UserID: loginobj?.UserID
        });
        var Settings = {};

        if (res && res.data) {
          Settings = JSON.parse(res.data);
          app.preloader.hide();

          if (Settings != null) {
            if (Settings.Switch == true) {
              $$("#checkedval").prop("checked", true);
            } else {
              $$("#checkedval").prop("checked", false);
            }
          }

          $$("#basicExample").val(Settings.HourFrom);
          $$("#basicExample2").val(Settings.HourTo);
        }

        return Settings;
      }

      var calendarRangeFrom = app.picker.create({
        inputEl: "#basicExample",
        dateFormat: {
          hour: "numeric",
          minute: "numeric"
        },
        closeOnSelect: true,
        rotateEffect: true,
        timePicker: true,
        position: "center",
        cols: [{
          textAlign: "left",
          values: function () {
            var arr = [];

            for (var i = 0; i <= 23; i++) {
              arr.push(i);
            }

            return arr;
          }()
        }, {
          divider: true,
          content: ":"
        }, // Minutes
        {
          values: function () {
            var arr = [];

            for (var i = 0; i <= 59; i++) {
              arr.push(i < 10 ? "0" + i : i);
            }

            return arr;
          }()
        }],
        on: {
          open: function (picker) {
            if (settings && settings.HourFrom) {
              let [hour, mins] = settings.HourFrom.split(":");
              picker.setValue([hour, mins]);
            }

            let [hour, mins] = settings.HourFrom.split(":");
            picker.setValue([hour, mins]);
          }
        }
      });
      var calendarRangeTo = app.picker.create({
        inputEl: "#basicExample2",
        dateFormat: {
          hour: "numeric",
          minute: "numeric"
        },
        closeOnSelect: true,
        rotateEffect: true,
        timePicker: true,
        position: "center",
        cols: [{
          textAlign: "left",
          textAlign: "left",
          values: function () {
            var arr = [];

            for (var i = 0; i <= 23; i++) {
              arr.push(i);
            }

            return arr;
          }()
        }, {
          divider: true,
          content: ":"
        }, {
          values: function () {
            var arr = [];

            for (var i = 0; i <= 59; i++) {
              arr.push(i < 10 ? "0" + i : i);
            }

            return arr;
          }()
        }],
        on: {
          open: function (picker) {
            //
            if (settings && settings.HourTo) {
              let [hour, mins] = settings.HourTo.split(":");
              picker.setValue([hour, mins]);
            }
          }
        }
      });
      $$("#PriceSaveBtn").on("click", async function () {
        var HourFrom = $$("#basicExample").val();
        var HourTo = $$("#basicExample2").val();
        var Switch = $$(".toggle-init input").prop("checked");
        var obj = {
          PropertyID: loginobj?.PropertyID,
          UserID: loginobj?.UserID,
          HourFrom: HourFrom,
          HourTo: HourTo,
          Switch: Switch
        };
        await app.request.promise.postJSON(URLS.SetNotificationSettings, {
          obj
        }).then(res => {
          app.preloader.hide();

          if (res.data == null) {
            app.preloader.hide();
            var toastCheckConnection = app.toast.create({
              text: "Error,check internet connection",
              position: "center",
              closeTimeout: 1500
            }).open();
          }

          app.dialog.alert(res.data.message, "Update");
        });
      });
    }
  },
  id: 'bc58f0d118',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=settings-donotdisturb><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i></a></div><div class="title sliding">Do not Distrurb</div><div class=right id=PriceSaveBtn style="margin-right: 10px"><span class=material-icons>save</span></div></div></div><div class=page-content><div class=block-title>Silence</div><div class=card><div class="card-content card-content-padding"><div class="list simple-list"><ul><li><span>Enable</span> <label class="toggle toggle-init color-blue"><input id=checkedval type=checkbox checked=checked> <span class=toggle-icon></span></label></li></ul></div></div></div><div class=row><div class="list no-hairlines-md"><ul><li><div class="item-content item-input"><div class=row><div class="col-50 fromclass" style="color: #0077ca; text-align: center"><span>From</span><div class=item-input-wrap><input type=text placeholder=21:00 readonly=readonly id=basicExample style="text-align: center"></div></div><div class=col-50><div class=fromclass style="color: #0077ca; text-align: center"><span>To</span></div><input type=text placeholder=07:00 readonly=readonly id=basicExample2 style="text-align: center"></div></div></div><div style="margin-left: 10px;\n                  margin-top: 25px;\n                  color: #646161;\n                  font-size: 15px;"><span>When you have the "do not disturb" function activated notifications coming in quiet hours will not be heard.</span></div></li></ul></div></div></div></div>';
      return r;
    }(this);
  },

  style: `
  .accountdiv {
    padding-left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));
  }

  .clearall {
    justify-content: flex-end;
    /* line-height: 2rem; */
    /* padding-left: 20px; */
    /* padding-right: 10px; */
    color: #3478f6;
    font-size: 18px;
    line-height: 3rem;
    width: 80%;
  }

  .accountdiv .profileicon {
    font-size: 35px !important;
    position: relative;
    top: 23px;
  }

  .list {
    margin: 10px;
  }

  .footer {
    padding-left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));
  }

  .icons {
    margin-right: 20px;
  }

  .footerlogoclass {
    margin-top: 10px;
    height: 2rem;
    width: auto;
  }

  .useremail {
    font-weight: 700;
  }

  .dialogcancelbtn {
    color: #eb4d3d;
  }

  .logoutbtn {
    color: #3478f6;
  }
`,
  styleScoped: false
};